module.exports = __webpack_public_path__ + "img/exclamation-point-blue.859fe71f.svg";